import TableHeader from "src/components/TableHeader";
import {
  OFFER_DETAILS_LISTS_TABLE_TITLE_SORT,
  OFFER_DETAILS_LISTS_TABLE_TITLE_WIDTHS,
  OFFER_DETAILS_LISTS_TITLES,
} from "src/helpers/Constants";
import { OfferDetailsTableSortType } from "src/helpers/Enums";

const ListsTable = ({
  sortedList,
  page,
  totalPages,
  onPageChange,
  setList,
  list,
}) => {
  return (
    <div className={"w-full flex flex-col justify-between"}>
      <div className={"w-full flex flex-col gap-3 px-6"}>
        <TableHeader
          titles={OFFER_DETAILS_LISTS_TITLES}
          widths={OFFER_DETAILS_LISTS_TABLE_TITLE_WIDTHS}
          sort={OFFER_DETAILS_LISTS_TABLE_TITLE_SORT}
          sortType={OfferDetailsTableSortType}
          setList={setList}
          list={list}
        />
        <div className="TableWrapper border-0">
          <table className="Table">
            <tbody className="flex flex-col gap-3">
              {!sortedList || sortedList.length === 0 ? (
                <tr>
                  <td colSpan={2} className="text-center py-8 text-gray-500">
                    No lists found
                  </td>
                </tr>
              ) : (
                sortedList.map((item, index) => (
                  <tr
                    key={index}
                    className="flex hover:bg-[#F6F6F9] rounded-lg border border-[#DBDFE8] text-[#15151F] text-[11px] font-medium leading-[14px] w-full"
                    style={{
                      fontFamily: "Inter",
                    }}
                  >
                    <td
                      className="py-3 px-[10px] border-r flex-shrink-0"
                      style={{
                        width: OFFER_DETAILS_LISTS_TABLE_TITLE_WIDTHS[0],
                      }}
                    >
                      <div className="flex items-center justify-start gap-[6px]">
                        <div className="flex px-1 justify-center items-center gap-[10px] rounded-[4px] bg-[#8185A8] text-white text-[10px] font-medium leading-[18px] font-['Inter']">
                          {item?.type?.toUpperCase()}
                        </div>
                        <div>{item?.name || item?.offer?.name || "N/A"}</div>
                      </div>
                    </td>
                    <td
                      className="py-3 px-5 border-r flex-shrink-0"
                      style={{
                        width: OFFER_DETAILS_LISTS_TABLE_TITLE_WIDTHS[1],
                      }}
                    >
                      {item?.avg_score != null ? item.avg_score : "-"}
                    </td>
                    <td
                      className="py-3 px-5 border-r flex-shrink-0"
                      style={{
                        width: OFFER_DETAILS_LISTS_TABLE_TITLE_WIDTHS[2],
                      }}
                    >
                      {item?.revenue || item?.total_revenue ? (
                        <div
                          className="inline-flex items-center h-[18px] px-[6px] rounded-[34px] bg-[#E5E7F0] text-[#15151F] text-[11px] font-semibold"
                          style={{ fontFamily: "Inter" }}
                        >
                          {"$" + item?.total_revenue}
                        </div>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td
                      className="py-3 px-5 border-r flex-shrink-0"
                      style={{
                        width: OFFER_DETAILS_LISTS_TABLE_TITLE_WIDTHS[3],
                      }}
                    >
                      -
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ListsTable;
